import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {LoginService} from '../../shared/services/login.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {
  @ViewChild('focusInput') focusInputElement: ElementRef;
  confirmPasswordControl: FormControl;
  passwordControl: FormControl;
  currentPasswordControl: FormControl;

  passwordControlGroup: FormGroup;

  passwordControlMinLength = 8;

  isRequesting: boolean;
  useSuccessfulStyle: boolean = false;

  updateErrorMessage: string;

  currentPassword: string;
  password: string;
  confirmPassword: string;

  constructor(private loginService: LoginService) {
    this.passwordControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.minLength(this.passwordControlMinLength)
    ])]);
    this.currentPasswordControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.minLength(this.passwordControlMinLength)
    ])]);
    this.confirmPasswordControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.minLength(this.passwordControlMinLength)
    ])]);

    this.passwordControlGroup = new FormGroup({
      password: this.passwordControl,
      confirmPassword: this.confirmPasswordControl
    }, (g: FormGroup): ValidationErrors => {
      return {areEqual: g.controls.password.value !== g.controls.confirmPassword.value};
    });
  }

  ngOnInit() {
    this.loginService.refreshToken();
  }

  ngAfterViewInit(): void {
    this.focusInputElement.nativeElement.focus();
  }

  get invalid(): boolean {
    return this.passwordControlGroup.hasError('areEqual') ||
      this.passwordControl.invalid || this.currentPasswordControl.invalid;
  }

  changePassword(): void {
    if (this.invalid) {
      this.updateErrorMessage = 'Please enter required information before submitting the request.';
      return;
    }
    this.updateErrorMessage = '';
    this.useSuccessfulStyle = false;
    this.isRequesting = true;
    this.loginService.changePassword(this.currentPassword, this.password,
      this.changePasswordOkCb.bind(this), this.changePasswordErrorCb.bind(this));
  }

  changePasswordOkCb(ok: boolean): void {
    this.isRequesting = false;
    this.useSuccessfulStyle = true;
    this.updateErrorMessage = 'Your password has been updated successfully.';
  }

  changePasswordErrorCb(err: HttpErrorResponse): void {
    this.isRequesting = false;
    if (err && err.error) {
      if (err.error.err instanceof Array) {
        const message: string = err.error.err.toString();
        const splicedMessage: string[] = message.split(',');
        if (splicedMessage.length > 0) {
          this.updateErrorMessage = splicedMessage.join('\n');
        }
      } else if (typeof err.error.err === 'string' || err.error.err instanceof String) {
        this.updateErrorMessage = err.error.err;
      } else {
        this.updateErrorMessage = 'Server Error';
      }
    } else {
      this.updateErrorMessage = 'Server Error';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/change-password/change-password.component.ts